/**
 * CSV 模板下载工具函数
 * 在前端生成并下载 CSV 模板文件
 */

/**
 * 下载 CSV 文件
 * @param {string} content - CSV 内容
 * @param {string} filename - 文件名
 */
export const downloadCsv = (content, filename) => {
    // 添加 BOM 以支持中文
    const BOM = '\uFEFF';
    const blob = new Blob([BOM + content], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);

    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // 释放 URL 对象
    URL.revokeObjectURL(url);
};

/**
 * 下载游戏导入模板
 */
export const downloadGameTemplate = () => {
    const content = `cName,eName,status
英雄联盟,League of Legends,enabled
王者荣耀,Honor of Kings,enabled
和平精英,Peacekeeper Elite,enabled`;
    downloadCsv(content, 'game_template.csv');
};

/**
 * 下载国家导入模板
 */
export const downloadCountryTemplate = () => {
    const content = `name,nameEn,code,status
中国,China,CN,enabled
美国,United States,US,enabled
日本,Japan,JP,enabled`;
    downloadCsv(content, 'country_template.csv');
};

/**
 * 下载地区导入模板
 */
export const downloadRegionTemplate = () => {
    const content = `name,nameEn,code,sort,status
亚洲,Asia,asia,1,enabled
欧洲,Europe,europe,2,enabled
北美,North America,north-america,3,enabled`;
    downloadCsv(content, 'region_template.csv');
};

/**
 * 下载平台导入模板
 */
export const downloadPlatformTemplate = () => {
    const content = `name,code,description,status
YouTube,youtube,全球最大的视频分享平台,enabled
Twitch,twitch,游戏直播平台,enabled
TikTok,tiktok,短视频社交平台,enabled`;
    downloadCsv(content, 'platform_template.csv');
};

